import React, { Component } from 'react';
import EditPilotPage from './EditPilotPage';
import EditUpgradePage from './EditUpgradePage';
import EditShipPage from './EditShipPage';
import PilotListPage from './PilotListPage';
import UpgradeListPage from './UpgradeListPage';
import ShipListPage from './ShipListPage';
import AddPage from './AddPage';
import { HashRouter as Router, Switch, Route, Link, NavLink, Redirect } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
// import NavLink from './NavLink';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: {
        collapsed: true,
      },
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  toggleMenu() {
    const { menu } = this.state;
    this.setState({
      menu: {
        collapsed: !menu.collapsed,
      },
    });
  }
  render() {
    const menuCollapsedClass = this.state.menu.collapsed ? '' : 'show';
    return (
      <Router>
        <ScrollToTop>
          <div className="App">
            <header className="App-header">
              {/* <Link to={`/`}>
                <h2 className="App-title">xwing-data crowdsourcing project</h2>
              </Link> */}
              <nav className="navbar navbar-expand-md navbar-light">
                <Link to={`/`} className="navbar-brand">
                  xwing-data crowdsourcing project
                </Link>
                <button onClick={this.toggleMenu} className="navbar-toggler" type="button">
                  <span className="navbar-toggler-icon" />
                </button>
                <div className={`collapse navbar-collapse ${menuCollapsedClass}`}>
                  <div className="navbar-nav">
                    <NavLink to={`/pilots`} className="nav-item nav-link">
                      Pilots
                    </NavLink>
                    <NavLink to={`/upgrades`} className="nav-item nav-link">
                      Upgrades
                    </NavLink>
                    <NavLink to={`/ships`} className="nav-item nav-link">
                      Ships
                    </NavLink>
                  </div>
                </div>
              </nav>
            </header>
            <Switch>
              <Route path={`/add`} component={AddPage} />
              <Route path={`/pilots/:id`} component={EditPilotPage} />
              <Route path={`/pilots`} component={PilotListPage} />
              <Route path={`/upgrades/:id`} component={EditUpgradePage} />
              <Route path={`/upgrades`} component={UpgradeListPage} />
              <Route path={`/ships/:id`} component={EditShipPage} />
              <Route path={`/ships`} component={ShipListPage} />
              <Redirect to={`/pilots`} />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js